
/**
 * <script defer 
 * src="https://podlytics.sandpod.ir/tracker.js"
 *  data-website-id="40dc2508-426d-4c78-a1ad-f65090c11ccf"
 * data-domains="localhost,http://businesspanel.devpod.ir"
 *  data-app-version="Insert your app release version here for tracking errors">
 * 
 * </script> 
 */
import { tagNumber } from 'config';

export function loadTracker() {
    const trackerAddress = process.env.REACT_APP_TRACKER_WEBSITE_ADDRESS;
    const trackerWebsiteId = process.env.REACT_APP_TRACKER_WEBSITE_ID;

    // Tracking is optional in local/development environments. Appending a script
    // with an undefined src makes the browser request `/undefined` and execute
    // the HTML response as JavaScript.
    if (!trackerAddress || !trackerWebsiteId) {
        return;
    }

    const script = document.createElement("script");
    script.src = trackerAddress;
    script.defer = true;
    script.setAttribute("data-website-id", trackerWebsiteId);
    script.setAttribute("data-app-version", tagNumber);
    script.setAttribute("data-domains", "localhost,businesspanel.devpod.ir,businesspanel.sandpod.ir");

    document.body.appendChild(script);
}

export function identifyTracker(user) {
    if (window.metrics?.identify) {
        window.metrics.identify(user);
    } else {
        console.warn("metrics.identify called before SDK ready", user);
    }
}  
